<template>
    <!-- Dashboard Sidebar
    ================================================== -->
    <div class="dashboard-sidebar hidden-xs hidden-md color-theme-green fadeIn animated">
        <div class="dashboard-sidebar-inner">
            <div class="dashboard-nav-container ">


                <div class="dashboard-nav ">
                    <div class="dashboard-nav-inner">
                        <center>
                            <span class="logo-mask" style="margin-bottom: 30px; margin-top: 30px;">
                                <img src="static/images/logo.png" class="logo-sidebar">
                            </span>
                        </center>
                        <ul v-if="$root.user.tipo == 'admin'">    
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Dashboard'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Dashboard'}">
                                    <i class="las la-tachometer-alt"></i>
                                    <span>Dashboard</span>
                                </router-link>
                            </li>
                            <li data-tooltip="Agende visitas avulsas, ou utilize os filtros para acompanhar o relatório de visitas." v-bind:class="{'active': $router.currentRoute.name == 'Visitas'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Visitas'}">
                                    <i class="las la-map-marker-alt"></i>
                                    <span>Visitas</span>
                                </router-link>
                            </li>
                            <li data-tooltip="Adicione planejamentos e agende visitas a clientes para toda sua equipe externa em poucos cliques." v-bind:class="{'active': $router.currentRoute.name == 'Planejamentos'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Planejamentos'}">
                                    <i class="las la-tasks"></i>
                                    <span>Planejamentos</span>
                                </router-link>
                            </li>
                            <li data-tooltip="Visualize o relatório completo de faturamento, você pode utilizar os filtros para melhorar sua busca." v-bind:class="{'active': $router.currentRoute.name == 'Faturamentos'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Faturamentos'}">
                                    <i class="las la-money-bill"></i>
                                    <span>Faturamento</span>
                                </router-link>
                            </li>
                            <li data-tooltip="Visualize o relatório completo de contratos, você pode filtrar e também adicionar novos contratos de clientes." v-bind:class="{'active': $router.currentRoute.name == 'Contratos'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Contratos'}">
                                    <i class="las la-file-invoice-dollar"></i>
                                    <span>Contratos</span>
                                </router-link>
                            </li>
                            <li data-tooltip="Aqui é possível cadastrar e gerenciar todos os usuários operacionais que terão acesso ao sistema." v-bind:class="{'active': $router.currentRoute.name == 'Usuarios'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Usuarios'}">
                                    <i class="las la-users"></i>
                                    <span>Usuários</span>
                                </router-link>
                            </li>
                            <li data-tooltip="Cadastre e gerencie as suas equipes externas." v-bind:class="{'active': $router.currentRoute.name == 'Equipes'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Equipes'}">
                                    <i class="las la-users-cog"></i>
                                    <span>Equipes</span>
                                </router-link>
                            </li>
                            <li data-tooltip="Acompanhe o relatório completo de clientes, é possível filtrar de acordo com sua necessidade." v-bind:class="{'active': $router.currentRoute.name == 'Clientes'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Clientes'}">
                                    <i class="las la-user-friends"></i>
                                    <span>Clientes</span>
                                </router-link>
                            </li>
                            <li data-tooltip="Visualize o relatório completo de notas fiscais emitidas." v-bind:class="{'active': $router.currentRoute.name == 'NotasFiscais'}" v-if="$root.logged">
                                <router-link :to="{'name': 'NotasFiscais'}">
                                    <i class="las la-file"></i>
                                    <span>Notas fiscais</span>
                                </router-link>
                            </li>                              
                            <li data-tooltip="Gerencie as configurações globais do sistema." v-bind:class="{'active': $router.currentRoute.name == 'Configuracoes'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Configuracoes'}">
                                    <i class="las la-cog"></i>
                                    <span>Configurações</span>
                                </router-link>
                            </li>
                            <li data-tooltip="Altere os dados da sua conta." v-bind:class="{'active': $router.currentRoute.name == 'Conta'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Conta'}">
                                    <i class="las la-user"></i>
                                    <span>Perfil do usuário</span>
                                </router-link>
                            </li>                                                                                                                                      
                            <li class="hidden-xl hidden-md hidden-lg">
                                <a data-tooltip="Clique para deslogar da sua conta." onclick="window.__app.logout()" v-if="$root.logged">
                                    <i class="las la-power-off"></i>
                                    <span>Sair</span>
                                </a>
                            </li>
                            <li :key="$root.sidebarToggleStatus" class="hidden-xs hidden-md hidden-sm">
                                <a onclick="window.__app.sidebarToggle()">
                                    <i v-if="!$root.sidebarToggleStatus" class="las la-arrow-circle-left"></i>
                                    <i v-if="$root.sidebarToggleStatus" class="las la-arrow-circle-right"></i>
                                </a>
                            </li>                            
                        </ul>

                        <ul v-if="$root.user.tipo == 'prestador'">    
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Dashboard'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Dashboard'}">
                                    <i class="las la-tachometer-alt"></i>
                                    <span>Dashboard</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Visitas'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Visitas'}">
                                    <i class="las la-map-marker-alt"></i>
                                    <span>Gerenciar visitas</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Conta'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Conta'}">
                                    <i class="las la-user"></i>
                                    <span>Perfil do usuário</span>
                                </router-link>
                            </li>                                                                                                                                      
                            <li>
                                <a onclick="window.__app.logout()" v-if="$root.logged">
                                    <i class="las la-power-off"></i>
                                    <span>Sair</span>
                                </a>
                            </li>
                            <li :key="$root.sidebarToggleStatus" class="hidden-xs hidden-md hidden-sm">
                                <a onclick="window.__app.sidebarToggle()">
                                    <i v-if="!$root.sidebarToggleStatus" class="las la-arrow-circle-left"></i>
                                    <i v-if="$root.sidebarToggleStatus" class="las la-arrow-circle-right"></i>
                                </a>
                            </li>                               
                        </ul>

                        <ul v-if="$root.user.tipo == 'contratante'">    
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Dashboard'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Dashboard'}">
                                    <i class="las la-tachometer-alt"></i>
                                    <span>Dashboard</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Visitas'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Visitas'}">
                                    <i class="las la-map-marker-alt"></i>
                                    <span>Visualizar visitas</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'OrdensServicos'}" v-if="$root.logged">
                                <router-link :to="{'name': 'OrdensServicos'}">
                                    <i class="las la-file-signature"></i>
                                    <span>Ordens de serviços</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Faturas'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Faturas'}">
                                    <i class="las la-dollar-sign"></i>
                                    <span>Minhas faturas</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'NotasFiscais'}" v-if="$root.logged">
                                <router-link :to="{'name': 'NotasFiscais'}">
                                    <i class="las la-file"></i>
                                    <span>Notas fiscais</span>
                                </router-link>
                            </li>                                
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Conta'}" v-if="$root.logged">
                                <router-link :to="{'name': 'Conta'}">
                                    <i class="las la-user"></i>
                                    <span>Perfil do usuário</span>
                                </router-link>
                            </li>                                                                                                                                      
                            <li>
                                <a onclick="window.__app.logout()" v-if="$root.logged">
                                    <i class="las la-power-off"></i>
                                    <span>Sair</span>
                                </a>
                            </li>
                            <li :key="$root.sidebarToggleStatus" class="hidden-xs hidden-md hidden-sm">
                                <a onclick="window.__app.sidebarToggle()">
                                    <i v-if="!$root.sidebarToggleStatus" class="las la-arrow-circle-left"></i>
                                    <i v-if="$root.sidebarToggleStatus" class="las la-arrow-circle-right"></i>
                                </a>
                            </li>                               
                        </ul>
                    </div>
                </div>
                

            </div>
        </div>
    </div>
   
</template>

<script>
export default {
    name: 'Sidebar',
    data () {
        return {
            'menu': ''
        }
    },
    methods: {
        openMenu: function(menu) {
            var self    = this;
            self.menu = menu;
            console.log('openMenu',menu);

            self.menu = menu;
        } 
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .dashboard-nav li ul {
        display: none;
    }

    .dashboard-nav li.open {
    }

    .dashboard-nav ul li a.submenu:after {
        content: "\f0d8";
        font-family: 'Line Awesome Free';
        font-weight: 900;
        font-size: 16px;
        opacity: 1;
        transition: .3s;
        opacity: 1;
        line-height: 17px;
        width: 17px;
        height: 17px;
        background-color: #f0f0f0;
        color: #a8a8a8;
        display: inline-block;
        border-radius: 3px;
        margin-left: 7px;
        text-indent: 0;
        top: 1px;
        position: absolute;
        right: 35px;
        top: 15px;
    }

    .dashboard-nav ul li.open a.submenu:after {
        transform: rotate(180deg) !important;
    }

    .dashboard-nav li.open ul {
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue